import { PAYMENT_AUTHORIZATION_ERROR } from './payments';

export enum CHECKOUT_STATUS {
    CREATED = 'created',
    CANCELED = 'canceled',
    PENDING = 'pending',
    REDIRECTED = 'redirected',
    COMPLETING = 'completing',
    COMPLETE = 'complete',
    PREORDER = 'preorder',
    SCHEDULED = 'scheduled',
    ERROR = 'error'
}

export enum CHECKOUT_ERROR {
    UNKNOWN_ERROR = 'unknown_error',
    AUTHORIZATION_UNKNOWN_ERROR = 'authorization_unknown_error',
    AUTHORIZATION_CVV_CODE_INCORRECT = 'authorization_cvv_code_incorrect',
    AUTHORIZATION_POST_CODE_INCORRECT = 'authorization_post_code_incorrect',
    AUTHORIZATION_INSUFFICIENT_FUNDS = 'authorization_insufficient_funds',
    AUTHORIZATION_CARD_NUMBER_INCORRECT = 'authorization_card_number_incorrect',
    AUTHORIZATION_CARD_EXPIRED = 'authorization_card_expired',
    ZERO_AMOUNT = 'zero_amount',
    SHIPPING_OPTIONS_NOT_FOUND = 'shipping_options_not_found'
}

export const PAYMENT_AUTHORIZATION_ERROR_TO_CHECKOUT_ERROR : {
    [paymentAuthorizationError in PAYMENT_AUTHORIZATION_ERROR] : CHECKOUT_ERROR
} = {
    [PAYMENT_AUTHORIZATION_ERROR.DUPLICATE]:                   CHECKOUT_ERROR.AUTHORIZATION_UNKNOWN_ERROR,
    [PAYMENT_AUTHORIZATION_ERROR.CVV_CODE_INCORRECT]:          CHECKOUT_ERROR.AUTHORIZATION_CVV_CODE_INCORRECT,
    [PAYMENT_AUTHORIZATION_ERROR.BILLING_ADDRESS_INCORRECT]:   CHECKOUT_ERROR.AUTHORIZATION_POST_CODE_INCORRECT,
    [PAYMENT_AUTHORIZATION_ERROR.BILLING_POST_CODE_INCORRECT]: CHECKOUT_ERROR.AUTHORIZATION_POST_CODE_INCORRECT,
    [PAYMENT_AUTHORIZATION_ERROR.INSUFFICIENT_FUNDS]:          CHECKOUT_ERROR.AUTHORIZATION_INSUFFICIENT_FUNDS,
    [PAYMENT_AUTHORIZATION_ERROR.CARD_NUMBER_INCORRECT]:       CHECKOUT_ERROR.AUTHORIZATION_CARD_NUMBER_INCORRECT,
    [PAYMENT_AUTHORIZATION_ERROR.CARD_EXPIRED]:                CHECKOUT_ERROR.AUTHORIZATION_CARD_EXPIRED,
    [PAYMENT_AUTHORIZATION_ERROR.TRANSACTION_NOT_ALLOWED]:     CHECKOUT_ERROR.AUTHORIZATION_UNKNOWN_ERROR,
    [PAYMENT_AUTHORIZATION_ERROR.REQUIRES_ACTION]:             CHECKOUT_ERROR.AUTHORIZATION_UNKNOWN_ERROR,
    [PAYMENT_AUTHORIZATION_ERROR.ZERO_AMOUNT]:                 CHECKOUT_ERROR.ZERO_AMOUNT,
    [PAYMENT_AUTHORIZATION_ERROR.INSTRUMENT_NOT_FOUND]:        CHECKOUT_ERROR.AUTHORIZATION_UNKNOWN_ERROR
};

export enum FINALIZE_CHECKOUT_STATUS {
    COMPLETE = 'complete',
    COMPLETE_REDIRECT = 'complete_redirect',
    REDIRECT_TO_CONTINUE = 'redirect_to_continue',
    RECENT_ORDER_CONFIRM = 'recent_order_confirm',
    AMOUNT_MISMATCH_CONFIRM = 'amount_mismatch_confirm',
    NO_STOCK_PREORDER_INITIATED = 'no_stock_preorder_initiated',
    NO_STOCK_PARTIAL_ORDER_INITIATED = 'no_stock_partial_order_initiated',
    NO_STOCK_FAILED = 'no_stock_failed',
    NO_EMAIL_FAILED = 'no_email_failed',
    SCHEDULED = 'scheduled'
}

export enum ORDER_TAGS {
    ONETEXT = 'Text Order',
    ONETEXT_REFILL = 'Text Refill',
    ONETEXT_REFILL_FIRST_ORDER = 'Text Refill 1st Order',
    ONETEXT_REFILL_REPEAT_ORDER = 'Text Refill Repeat Order',
    ONETEXT_FAILED_REFUND = 'Failed Refund'
}
